<template>
  <div>
    <hshead title="订单详情" irregularBg="true"></hshead>
    <div class="detail-box">
      <div class="detail-h1">广州市天河区W酒店</div>
      <div class="detail-map">广州省广州市天河区黄埔大道888号</div>
      <div class="detail-line">
          <van-steps :active="active" active-color="#3cf">
          <van-step>已下单</van-step>
          <van-step>已接单</van-step>
          <van-step>待拍摄</van-step>
          <van-step>订单完成</van-step>
        </van-steps>
      </div>
      <div class="detail-block">
        <div class="this-title">商品信息</div>
        <div class="this-img-box">
          <div class="left-img">
            <img src="../assets/images/order/detail.png" alt />
          </div>
          <div class="center-p">
            <div class="center-p-h1">高级套餐</div>
            <div class="center-p-h2">¥800.00</div>
            <div class="center-p-h3">去拍拍官方自营店</div>
          </div>
          <div class="right-p">×30张</div>
        </div>
      </div>
      <div class="detail-block">
        <div class="this-title">
          订单信息-11977240
          <a href class="href-btn">联系客户</a>
        </div>
        <div class="this-form-box">
          <div class="this-p-box">
            <div class="left-p">联系人:</div>
            <div class="right-p">陈先生/1388013800</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">预拍摄日期：</div>
            <div class="right-p">2019-5-1 至 2019-5-7</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">下单日期：</div>
            <div class="right-p">2019-4-29 12:00</div>
          </div>
        </div>
      </div>
      <div class="detail-block">
        <div class="this-title">摄影师信息</div>
        <div class="this-form-box">
          <div class="this-p-box">
            <div class="left-p">摄影师：</div>
            <div class="right-p">李大师</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">联系电话：</div>
            <div class="right-p">13800167823</div>
          </div>
          <div class="this-p-box">
            <div class="left-p">约拍时间：</div>
            <div class="right-p">22019-5-3 至 2019-5-9</div>
          </div>
        </div>
      </div>
      <div class="detail-block">
        <div class="this-title">摄影师信息</div>
        <div class="this-form-box">
          <div class="this-txt">加紧拍摄，需要全房型拍摄</div>
        </div>
      </div>
      <div class="bottom-btn-box">
        <a href="javascript:;" class="bottom-btn noBg">取消订单</a>
        <router-link to class="bottom-btn">预约</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {Step, Steps } from "vant";
import hshead from "@/components/common/hshead";
export default {
  name: "index",
  data() {
    return {
        active: 2
    };
  },
  components: {
    hshead,
    "van-steps": Steps,
    "van-step": Step,
  }
};
</script>

<style lang="less" scoped>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.detail-box {
  margin-top: -6.2rem;
  margin-bottom: 1.2rem;
  .detail-h1 {
    font-family: PingFang-SC-Medium;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    padding-left: 0.65rem;
    padding-bottom: 0.35rem;
  }
  .detail-map {
    font-family: PingFang-SC-Medium;
    font-size: 0.32rem;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0rem;
    color: #ffffff;
    padding-left: 1.1rem;
    line-height: 0.4rem;
    margin-bottom: 0.5rem;
    background: url(../assets/images/order/mapw.png) 0.62rem center no-repeat;
    background-size: 0.25rem 0.37rem;
  }
  .detail-line {
      width: 6.9rem;
    background-color: #ffffff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    overflow: hidden;
  }
  .detail-block {
    width: 6.9rem;
    background-color: #ffffff;
    box-shadow: 0rem 0.01rem 0.18rem 0rem rgba(129, 135, 148, 0.18);
    border-radius: 0.1rem;
    margin: 0 auto;
    margin-bottom: 0.35rem;
    .this-title {
      height: 0.83rem;
      line-height: 0.83rem;
      font-family: PingFang-SC-Medium;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      color: #00b8f5;
      position: relative;
      border-bottom: 1px solid #e5e5e5;
      padding-left: 0.35rem;
      &::before {
        content: "";
        width: 0.08rem;
        height: 0.25rem;
        background-image: linear-gradient(135deg, #33ccff 0%, #0095ff 100%),
          linear-gradient(#000000, #000000);
        background-blend-mode: normal, normal;
        border-radius: 0.04rem;
        position: absolute;
        left: 0.15rem;
        top: 0.28rem;
      }
      .href-btn {
        position: absolute;
        width: 1.46rem;
        height: 0.46rem;
        line-height: 0.46rem;
        border-radius: 0.23rem;
        border: solid 0.01rem #00aae5;
        font-family: PingFang-SC-Medium;
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0rem;
        color: #00aae5;
        top: 0.2rem;
        right: 0.2rem;
        text-align: center;
      }
    }
    .this-img-box {
      display: flex;
      padding: 0.3rem 0.28rem 0.33rem 0.26rem;
      .left-img {
        width: 2.42rem;
        height: 2.03rem;
        background-color: #000000;
        overflow: hidden;
        img {
          width: 2.42rem;
        }
      }
      .center-p {
        width: 2.8rem;
        padding-left: 0.3rem;
        .center-p-h1 {
          font-family: PingFang-SC-Bold;
          font-size: 0.28rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.48rem;
          letter-spacing: -0.01rem;
          color: #333333;
        }
        .center-p-h2 {
          font-family: PingFang-SC-Medium;
          font-size: 0.28rem;
          font-weight: bold;
          font-stretch: normal;
          line-height: 0.4rem;
          letter-spacing: 0rem;
          color: #ff3087;
        }
        .center-p-h3 {
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.34rem;
          letter-spacing: 0rem;
          color: #8a9096;
        }
      }
      .right-p {
        font-family: PingFang-SC-Medium;
        font-size: 0.22rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.4rem;
        letter-spacing: 0rem;
        color: #00bbfb;
        text-align: right;
      }
    }
    .this-form-box {
      padding: 0.3rem;
      .this-p-box {
        display: flex;
        .left-p {
          width: 1.9rem;
          height: 0.23rem;
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.6rem;
          letter-spacing: -0.01rem;
          color: #999999;
        }
        .right-p {
          font-family: PingFang-SC-Medium;
          font-size: 0.24rem;
          font-weight: normal;
          font-stretch: normal;
          line-height: 0.6rem;
          letter-spacing: -0.01rem;
          color: #333333;
        }
      }
      .this-txt {
        font-size: 0.24rem;
        font-weight: normal;
        font-stretch: normal;
        line-height: 0.48rem;
        letter-spacing: -0.01rem;
        color: #333333;
      }
    }
  }
  .bottom-btn-box {
    width: 7.5rem;
    height: 0.98rem;
    background-color: #ffffff;
    box-shadow: 0rem -0.01rem 0.05rem 0rem #e5e5e5;
    position: fixed;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    .bottom-btn {
        margin-top: 0.15rem;
      display: block;
      width: 2.6rem;
      height: 0.68rem;
      line-height: 0.68rem;
      background-image: linear-gradient(-89deg, #348ff5 0%, #2fa9ff 100%),
        linear-gradient(#333333, #333333);
      background-blend-mode: normal, normal;
      box-shadow: 0rem 0.04rem 0.2rem 0rem rgba(49, 160, 252, 0.38);
      border-radius: 0.34rem;
      color: #fff;
      font-size: 0.32rem;
      text-align: center;
      &.noBg {
        color: #329bf9;
        background: transparent;
        border: 1px solid #329bf9;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/orderDetail.vue